import { Injectable } from "@angular/core";
import { ApiClient } from "../api-client/api-client";
import { Observable } from "rxjs";
import { OpeningHours } from "src/app/model/interfaces/opening-hours";
import { OpeningHoursRequest } from "src/app/model/api/api-request/opening-hours-request";
import { SupportMessageRequest } from "src/app/model/api/api-request/support-message-request";
import { AppConfigService } from "src/app/services/app-config.service";
import { SupportMessage } from "src/app/model/interfaces/support-message";
import { SupportMessageResponse } from "src/app/model/api/api-request/support-message-response";

@Injectable({providedIn: 'root'})
export class SupportRepository
{
    private apiClient: ApiClient;

    public constructor(apiClient: ApiClient, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
    }

    public getOpeningHours(): Observable<OpeningHours>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        var request = new OpeningHoursRequest(webapiBasepath);
        return this.apiClient.get(request);
    }

    public sendMessage(MessageObject: SupportMessage): Observable<SupportMessageResponse>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        var request = new SupportMessageRequest(MessageObject, webapiBasepath);
        return this.apiClient.post(request);
    }
}
